'use strict';

angular.module('ClinicApp').factory('AvailabilityService', function($http, ClinicConfig) {
  return {
    listForProviders: function(providerIds, date, days) {
      return $http.get(ClinicConfig.HOSTNAME + '/provider/reservedAppointmentSlots', {
        params: {
          'providerIds[]': providerIds,
          date: date,
          days: days,
        },
      }).then(function(response) {
        return response.data;
      });
    },

    countForProviders: function(providerIds, date, days) {
      return $http.get(ClinicConfig.HOSTNAME + '/provider/reservedAppointmentSlots/count', {
        params: {
          'providerIds[]': providerIds,
          date: date,
          days: days,
        },
      }).then(function(response) {
        return response.data.count;
      });
    },
  };
});
